import { JConn } from '../../models/dbversion/jconn';
import { JDatabase } from '../../models/dbversion/jdatabase';
import { JVersion } from '../../models/dbversion/jversion';

/** One connector type (dbTyp_Id) with the distributions the Data Point screen offers for it. */
export interface ConnectorCatalogEntry {
  connTypeId: number;
  connTypeName: string;
  distributions: Array<JDatabase>;
}

/** Row shape of GET /api/v1/connectors (purplecube-etl only). */
export interface ApiConnector {
  connTypeId: number;
  connTypeName?: string;
  distributions?: Array<{ name: string; code?: string }>;
}

/**
 * purplecube-etl: connector types and distributions come only from GET /api/v1/connectors. ETL has no
 * jars.xml and does not support multiple versions, so every distribution has an empty version list.
 */
export function catalogFromApi(apiConnectors: Array<ApiConnector> | null | undefined): Array<ConnectorCatalogEntry> {
  return (apiConnectors || []).map(apiConnector => ({
    connTypeId: apiConnector.connTypeId,
    connTypeName: apiConnector.connTypeName || '',
    distributions: (apiConnector.distributions || []).map(distribution => {
      const jDatabase = new JDatabase();
      jDatabase.name = distribution.name;
      jDatabase.value = distribution.code || '';
      jDatabase.dBVersions = new Array<JVersion>();
      return jDatabase;
    })
  }));
}

/**
 * purplecube-backend (Java 8): there is no /api/v1/connectors, so connector types, distributions and
 * versions all come from jars.xml (GET /service/studio/jars_xml).
 */
export function catalogFromJars(jConns: Array<JConn> | null | undefined): Array<ConnectorCatalogEntry> {
  return (jConns || []).map(jConn => ({
    connTypeId: jConn.id,
    connTypeName: '',
    distributions: jConn.jDatabases || []
  }));
}
